import { useEffect } from 'react';
import { MESSAGE_TYPES } from '../constants/simulationConstants';
import { useSimulationContext } from '../providers/SimulationProvider';

/**
 * Listens for the parent app's avatar show/hide toggle.
 *
 * Hiding the avatar tears down the Anam session entirely (see AnamVideoStream)
 * so it stops consuming Anam usage. The Nudgyt websocket that carries the
 * conversation is independent of Anam, and the coach voice falls back to local
 * MP3 playback, so the simulation keeps working while hidden.
 *
 * Mounted at the container level so the state exists before the renderer is
 * known. For the ThreeJS renderer there is no Anam session to stop, so hiding
 * is mostly the parent's CSS — the flag only tells the client to initialize
 * without waiting for a scene that will never mount (useThreeNudgytAgentClient).
 */
function useAvatarVisibilityListener() {
  const { setIsAvatarHidden } = useSimulationContext();

  useEffect(() => {
    const handleMessage = (event) => {
      let receivedData = event.data;

      if (typeof receivedData === 'string') {
        try {
          receivedData = JSON.parse(receivedData);
        } catch (err) {
          return;
        }
      }

      if (
        receivedData?.type === MESSAGE_TYPES.AVATAR_VISIBILITY &&
        typeof receivedData.payload?.hidden === 'boolean'
      ) {
        setIsAvatarHidden(receivedData.payload.hidden);
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [setIsAvatarHidden]);
}

export default useAvatarVisibilityListener;
